import React from 'react';

interface PlusProps {
  width?: number;
  color?: string;
}

const Plus = ({ width = 20, color = '#9498A7' }: PlusProps) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9.25" stroke={color} strokeWidth="1.5" />
    <rect x="9.23077" y="6.15381" width="1.53846" height="8.46154" rx="0.769231" fill={color} />
    <rect
      x="14.2308"
      y="9.61523"
      width="1.53846"
      height="8.46154"
      rx="0.769231"
      transform="rotate(90 14.2308 9.61523)"
      fill={color}
    />
  </svg>
);

export default Plus;
